import React from "react";
import { motion } from "framer-motion";
import Fixed from "./Fixed";
import Footer1 from "./Footer1";
import giftHero from "../Assets/service4.png";
//import giftImage1 from "../Assets/gift1.jpg";
//import giftImage2 from "../Assets/gift2.jpg";
//import giftImage3 from "../Assets/gift3.jpg";

const GiftCardsAndValueAddedServices = () => {
  return (
    <div>
      <Fixed />
      <div className="bg-gray-50 text-gray-900 pt-20">
        {/* Hero Section */}
        <section
          className="relative w-full h-screen flex items-center justify-center bg-cover bg-center text-center text-white"
          style={{ backgroundImage: `url(${giftHero})` }}
        >
          <div className="absolute inset-0 bg-black bg-opacity-50"></div>
          <div className="relative z-10 px-6">
            <motion.h1
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1 }}
              className="text-5xl font-extrabold text-white"
            >
              Gift Cards & Value-Added Services
            </motion.h1>
            <p className="mt-4 text-lg max-w-3xl mx-auto">
              Elevate gifting and rewards with customized, flexible, and seamless gift card solutions.
            </p>
          </div>
        </section>

        {/* Our Services Section */}
        <section className="container mx-auto px-6 py-16">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
            className="bg-gradient-to-br from-purple-50 to-white shadow-lg rounded-lg p-10"
          >
            <h2 className="text-4xl font-bold text-purple-700 text-center">Our Gift Card Solutions</h2>
            <p className="mt-4 text-lg text-gray-700 text-center">
              Offering versatile gift cards, corporate rewards, and seamless digital solutions for businesses and customers.
            </p>

            <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-8">
              {[{
                  title: "Custom Gift Cards",
                  description: "Personalized gift cards tailored to your brand and customer needs.",
                },
                {
                  title: "Corporate Rewards",
                  description: "Enhance employee engagement with easy-to-use digital reward solutions.",
                },
                {
                  title: "E-Gift Cards",
                  description: "Instant and secure digital gift cards for seamless online gifting.",
                }
              ].map((service, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 30 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.8, delay: index * 0.2 }}
                  className="bg-white p-6 rounded-lg shadow-md border-b-4 border-purple-500"
                >
                  <h3 className="text-2xl font-semibold text-purple-600">{service.title}</h3>
                  <p className="mt-2 text-gray-700">{service.description}</p>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </section>

        {/* Features Section */}
        {/* Why Choose Our Services */}
<section className="bg-gradient-to-r from-purple-50 to-white py-16">
  <div className="container mx-auto px-6 text-center">
    <h2 className="text-4xl font-bold text-purple-800">Why Choose Our Services?</h2>
    <p className="mt-4 text-lg text-gray-700 max-w-2xl mx-auto">
      Experience seamless transactions, instant delivery, and secure payment methods with our premium gift card and value-added services.
    </p>

    <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-10">
      {[
        {
          title: "Instant Delivery",
          description: "Receive your gift cards instantly via email or SMS with secure transaction processing.",
          icon: "🚀",
        },
        {
          title: "Flexible Redemption",
          description: "Use your gift cards across multiple platforms and brands with ease.",
          icon: "🔄",
        },
        {
          title: "Secure Transactions",
          description: "Our robust encryption ensures your payments and data remain protected at all times.",
          icon: "🔒",
        },
      ].map((feature, index) => (
        <motion.div
          key={index}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: index * 0.2 }}
          className="bg-white p-8 rounded-2xl shadow-xl border-t-4 border-purple-500 flex flex-col items-center"
        >
          <div className="text-5xl">{feature.icon}</div>
          <h3 className="text-2xl font-semibold text-purple-700 mt-4">{feature.title}</h3>
          <p className="mt-2 text-gray-600 text-center">{feature.description}</p>
        </motion.div>
      ))}
    </div>
  </div>
</section>

        {/* Contact Section */}
        <section className="py-16 text-center bg-white border-t border-gray-300">
          <div className="container mx-auto px-6">
            <h2 className="text-4xl font-bold text-purple-800">Get Your Gift Card Solution Today</h2>
            <p className="mt-4 text-lg text-gray-700">Make gifting seamless, secure, and rewarding for everyone.</p>
          </div>
        </section>
      </div>
      <Footer1 />
    </div>
  );
};

export default GiftCardsAndValueAddedServices;
